import { useEffect, useState } from "react";
import { subscribe, getState } from "util/networkActivity";

/**
 * 네트워크 요청 진행 중(busy)이면 true — 빈 상태 문구를 로딩 완료 후에만 보여주는 게이트.
 *  (silent 요청(배지 폴링 등)은 begin() 을 부르지 않아 영향 없음)
 */
export function useNetBusy() {
  const [busy, setBusy] = useState(() => getState().busy);
  useEffect(() => subscribe((s) => setBusy(s.busy)), []);
  return busy;
}

// 빈 상태 공용 뷰 — 로딩(프로그래스) 중에는 렌더하지 않는다.
//  종전: 데이터 도착 전 "…없습니다" 가 오버레이 뒤로 비쳐 보임 → 완료 후에만 표시.
const EmptyView = ({ title, content, btnTitle, btnOnclick }) => {
  const busy = useNetBusy();
  // 마운트 직후 fetch 시작 전 1프레임 노출 방지 — idle 150ms 유지 후에만 표시.
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (busy) { setReady(false); return undefined; }
    const t = setTimeout(() => setReady(true), 150);
    return () => clearTimeout(t);
  }, [busy]);
  if (busy || !ready) return null;

  return (
    <div className="list-none">
      <i className="filled-nodata"></i>
      {title && <p className="t-18-single fw-m fc-h ta-c">{title}</p>}
      {content && <p className="t-14-single fw-m fc-g600 ta-c">{content}</p>}
      {btnTitle && <button onClick={btnOnclick} type="button" className="round-btn-md outlined">{btnTitle}</button>}
    </div>
  );
};

export default EmptyView;
